import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { endpoints } from "@/lib/api";
import { pushSupported, enablePush } from "@/lib/push";

const rid = () => `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
const vid = () => { let v = localStorage.getItem("bbk_vid"); if (!v) { v = rid(); localStorage.setItem("bbk_vid", v); } return v; };
const sid = () => {
  let s = sessionStorage.getItem("bbk_sid");
  if (!s) { s = rid(); sessionStorage.setItem("bbk_sid", s); }
  return s;
};
const send = (kind, path) => endpoints.analyticsHit({ kind, vid: vid(), sid: sid(), path, ref: kind === "view" ? document.referrer : "", w: window.innerWidth, lang: navigator.language }).catch(() => {});
const ASKED = "bbk_push_native_asked";

// Silent anonymous visit counting (covered by our terms) + notifications with no custom pop-ups:
// already allowed → subscribe silently; not decided → the browser's own prompt once, on the first tap.
export function EngagementLayer() {
  const loc = useLocation();

  useEffect(() => { send("view", loc.pathname); }, [loc.pathname]);
  useEffect(() => {
    const t = setInterval(() => { if (document.visibilityState === "visible") send("ping", loc.pathname); }, 60000);
    return () => clearInterval(t);
  }, [loc.pathname]);

  useEffect(() => {
    if (!pushSupported()) return undefined;
    if (Notification.permission === "granted") { enablePush({ silent: true }).catch(() => {}); return undefined; }
    if (Notification.permission !== "default" || localStorage.getItem(ASKED)) return undefined;
    const onTap = () => {
      window.removeEventListener("pointerup", onTap, true);
      localStorage.setItem(ASKED, "1");
      enablePush({ silent: true }).catch(() => {});
    };
    window.addEventListener("pointerup", onTap, true);
    return () => window.removeEventListener("pointerup", onTap, true);
  }, []);

  return null;
}
